import {graphql, useStaticQuery} from 'gatsby'
import React from 'react'

import type {FooterQuery} from '@/graphql-types'
import {Footer as FooterComponent} from '@helios/shared/components/footer'
import {useLocalizedContent} from '@helios/shared/hooks/use-localized-content'

interface Props {
    hideLinks?: boolean
}

const Footer = ({hideLinks}: Props) => {
    const {allPrismicFooter} = useStaticQuery<FooterQuery>(query)
    const [content] = useLocalizedContent(allPrismicFooter.nodes)

    return (
        <FooterComponent
            hideLinks={hideLinks}
            content={{
                ...content.data,
                address: content.data.address.richText,
                financial_partner_terms_text: content.data.financial_partner_terms_text.richText,
            }}
        />
    )
}

const query = graphql`
    query Footer {
        allPrismicFooter {
            nodes {
                lang
                data {
                    entity
                    address {
                        richText
                    }
                    cvr
                    terms_body
                    copyright_text
                    financial_partner_terms_text {
                        richText
                    }
                    financial_partner_copyright_text
                    contact_us
                    sales_email
                    info_email
                    support_email
                    product_heading
                    resources_heading
                    company_heading
                    legal_heading
                    solutions_heading
                    partnerships_heading
                    product_links {
                        text
                        link {
                            ...PrismicLink
                        }
                    }
                    resources_links {
                        text
                        link {
                            ...PrismicLink
                        }
                    }
                    company_links {
                        text
                        link {
                            ...PrismicLink
                        }
                    }
                    legal_links {
                        text
                        link {
                            ...PrismicLink
                        }
                    }
                    solutions_links {
                        text
                        link {
                            ...PrismicLink
                        }
                    }
                    partnerships_links {
                        text
                        link {
                            ...PrismicLink
                        }
                    }
                }
            }
        }
    }
`

export default Footer
